import {AdItem} from '../ad-item';

export const LOAD_ADS = 'LOAD_ADS';
export const LOAD_ADS_SUCCESS = 'LOAD_ADS_SUCCESS';
export const LOAD_ADS_FAILED = 'LOAD_ADS_FAILED';


export class LoadAdsAction {
  readonly type = LOAD_ADS;
}

export class LoadAdsSuccessAction {
  readonly type = LOAD_ADS_SUCCESS;
  constructor(public payload: AdItem[]) { }
}

export class LoadAdsFailedAction {
  readonly type = LOAD_ADS_FAILED;
}


export type AdAction = LoadAdsAction | LoadAdsSuccessAction | LoadAdsFailedAction;



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/adds/store/ad.actions.ts